import styled, { css } from 'styled-components';
import Icon from '../Icon';

const iconStyle = css`
  margin-right: 6.5px;
  color: ${({ theme }) => theme.colors.greyDark};
`;

const iconSize15 = css`
  width: 15px;
  height: 15px;
`;

const iconSize20 = css`
  width: 20px;
  height: 20px;
`;

export const CheckinIcon = styled(Icon)`
  ${iconStyle}
  ${iconSize15}
`;

export const CheckoutIcon = styled(Icon)`
  ${iconStyle}
  ${iconSize15}
transform: rotate(180deg);
`;

export const DollarIcon = styled(Icon)`
  ${iconStyle}
  ${iconSize20}
`;

export const SmileyIcon = styled(Icon)`
  ${iconStyle}
  ${iconSize20}
`;
